import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type {
  DeletePurchaseUploadRequest,
  ImportPurchaseFileRequest,
  ParsePurchaseFileRequest,
  PurchaseUploadListItem,
} from '@erp/rpc';

export function useParsePurchaseFile() {
  return useMutation({
    mutationFn: (input: ParsePurchaseFileRequest) =>
      rpcClient.rebates.purchaseUpload.parse(input),
  });
}

export function useImportPurchaseFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ImportPurchaseFileRequest) =>
      rpcClient.rebates.purchaseUpload.import(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: orpc.rebates.purchaseTrend.get.key(),
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.rebates.purchaseUpload.list.key(),
      });
    },
  });
}

export function useDeletePurchaseUpload() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: DeletePurchaseUploadRequest) =>
      rpcClient.rebates.purchaseUpload.delete(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: orpc.rebates.purchaseTrend.get.key(),
      });
      void queryClient.invalidateQueries({
        queryKey: orpc.rebates.purchaseUpload.list.key(),
      });
    },
  });
}

export function usePurchaseUploads(year: number, enabled = true) {
  return useQuery({
    ...orpc.rebates.purchaseUpload.list.queryOptions({ input: { year } }),
    enabled,
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    select: (result: { data: PurchaseUploadListItem[] }) => result.data,
  });
}
